export default __webpack_public_path__ + "static/feature-bg-inverted-76109bd4795d6e0d3b870437c310c248.svg";